// extracted by mini-css-extract-plugin
export default {"TabLabel":"TabLabel_TabLabel__ECNF5","TabBadge":"TabLabel_TabBadge__Fhn7S"};